import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMachine } from '@/api/machines'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { MachineArchiveActions } from '@/components/machines/machine-archive-actions'
import { MachineForm } from '@/components/machines/machine-form'
import { MachineBadges } from '@/components/machines/machine-badges'

// Machine edit (UI-SCREENS F-02, #127), with archive / un-archive (#126 Q1). Owner only; rate
// input changes are audited (`machine_rate_change`) by the API.
export const Route = createFileRoute('/w/$slug/machines/$machineId/edit')({
  component: EditMachine,
  staticData: { breadcrumb: 'machines.form.editTitle' },
})

function EditMachine() {
  const { t } = useTranslation()
  const { slug, machineId } = Route.useParams()
  const workspace = useWorkspace(slug)
  const machine = useMachine(slug, Number(machineId))

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/machines/$machineId" params={{ slug, machineId }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('machines.form.editTitle')}</h1>
      {machine.isPending ? (
        <LoadingSkeleton variant="form" rows={4} />
      ) : machine.isError || !machine.data ? (
        <p role="alert" className="text-sm text-destructive">
          {t('errors.generic')}
        </p>
      ) : (
        <>
          <MachineBadges machine={machine.data} />
          <MachineForm slug={slug} machine={machine.data} />
          <MachineArchiveActions slug={slug} machine={machine.data} />
        </>
      )}
    </section>
  )
}
